// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"style_titleWrapper__s8yrQ","rowsWrapper":"style_rowsWrapper__2D9Ai","rowWrapper":"style_rowWrapper__30WPd"};